import script from "./Pagination.vue?vue&type=script&setup=true&lang=js"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=14ec9165&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14ec9165"]])

export default __exports__